import './LoadingOverlay.css'

const LoadingOverlay = ({ children, className = '', label = 'Loading' }) => {
  return (
    <div
      className={`loading-overlay ${className}`}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <div className="loading-overlay__content">
        {children}
      </div>
    </div>
  )
}

export default LoadingOverlay
